

export default {
  name: 'AccountForgotPage',
  data() {
    return {
      config: {
        placement: 'account',
        submit_text: 'Send me a reset link',
        submit_icon: false,
        return_text: 'Back to Sign In',
        component_animation: '',
        background_animation: 'animate__animated animate__fadeInLeft',
        form_animation: 'animate__animated animate__fadeInRight',
        forgot_header: {
          title: 'Forgot Your Password?',
          helper: 'Please enter your email to reset your password',
          icon: {
            name: 'eye-icon',
            classes: '',
          },
        }
      }
    }
  },
  head() {
    return this.$utils.head(this.story)
  },
  async asyncData({ $utils }) {
    const forgot = await $utils.content('account/forgot')
    if (!forgot) {
      return {
        story: null,
        forgotStoryblok: undefined,
      }
    }

    const sections = forgot.content.sections || []
    const sectionFound = sections.find(section => section.component === 'sign-in-up-forgot-confirmed')
    const forgotStoryblok = sectionFound ? sectionFound : null

    return {
      story: forgot,
      forgotStoryblok,
    }
  },
}
